<template>
	<div class="w-full">
		<vs-row  class="mb-4">
			<vs-col  vs-type="flex" vs-justify="flex-start" vs-align="flex-end" vs-w="6" vs-sm="12" class="text-left px-2">
				<Default :index="index" :label="$t('MODULE.selectModeView')"></Default>
			</vs-col>
		</vs-row>
		<vs-row vs-justify="center">
			<vs-col  vs-type="flex" vs-justify="center" vs-align="flex-end" vs-w="12" vs-sm="12" class="text-left px-2">
				<vs-textarea :label="$t('MODULE.inputParagraph')" v-model="questionsByPage[index].content" />
			</vs-col>
		</vs-row>
		
	</div>
</template>

<script type="text/javascript">
	import Default from '../../componentsToQuestions/DefaultSelect.vue';
	import { mapState } from 'vuex';

	export default {
		props: ['index'],
		components: { Default },
		computed: {
			...mapState('resource',['questionsByPage']),
		}

	}
</script>